import React, { useEffect, createContext, useState } from "react";
import {
  getLessonOutlines,
  getLessonData,
  getSupportingContent,
} from "../services/lessons";
import { useSelector } from "react-redux";
import { getClients, getClientByUser } from "../services/clients";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const activeUser = useSelector((state) => state.users.activeUser);
  const [lessonID, setLessonID] = useState(null);
  const [lesson, setLesson] = useState(null);
  const [
    lessonsSupportingContentID,
    setLessonsSupportingContentID,
  ] = useState();
  const [
    affirmationsSupportingContentID,
    setAffirmationsSupportingContentID,
  ] = useState();
  const [lessonOutlines, setLessonOutlines] = useState(null);
  const [supportingContent, setSupportingContent] = useState(null);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState();
  const [workflow, setWorkflow] = useState(null);
  const [archive, setArchive] = useState(null);

  useEffect(() => {
    if (activeUser) {
      if (activeUser.user_type === "admin") {
        const fetchClients = async () => {
          try {
            const clients = await getClients();
            setClients(clients);

            const storedSelectedClient = localStorage.getItem("selectedClient");
            const sclient = storedSelectedClient
              ? JSON.parse(storedSelectedClient)
              : clients[0];
            setSelectedClient(sclient);
          } catch (error) {
            console.error(error);
          }
        };
        fetchClients();
      } else if (activeUser.user_type === "client admin") {
        const fetchClient = async () => {
          try {
            const client = await getClientByUser(activeUser.public_id);
            setSelectedClient(client);
          } catch (error) {
            console.error(error);
          }
        };
        fetchClient();
      }
    }
  }, [activeUser]);

  useEffect(() => {
    if (selectedClient) {
      localStorage.setItem("selectedClient", JSON.stringify(selectedClient));
    }
  }, [selectedClient]);

  useEffect(() => {
    const loadLessonOutlineData = async () => {
      if (lessonsSupportingContentID) {
        let response = await getLessonOutlines(lessonsSupportingContentID);
        if (response.success) {
          setLessonOutlines(response.supporting_content_items);
        }

        response = await getSupportingContent(lessonsSupportingContentID);
        if (response.success) {
          setSupportingContent(response.supporting_content);
        }
      }
    };

    loadLessonOutlineData();
  }, [lessonsSupportingContentID]);

  useEffect(() => {
    const loadLessonData = async () => {
      if (lessonID) {
        const response = await getLessonData(lessonID);
        if (response.success) {
          setLesson(response.supporting_content_items);
        }
      }
    };

    loadLessonData();
  }, [lessonID]);

  const addClient = (client) => {
    setClients([...clients, client]);
  };

  return (
    <AppContext.Provider
      value={{
        lesson,
        setLesson,
        lessonID,
        setLessonID,
        lessonOutlines,
        setLessonOutlines,
        lessonsSupportingContentID,
        setLessonsSupportingContentID,
        affirmationsSupportingContentID,
        setAffirmationsSupportingContentID,
        supportingContent,
        setSupportingContent,
        clients,
        setClients,
        addClient,
        selectedClient,
        setSelectedClient,
        workflow,
        setWorkflow,
        archive,
        setArchive,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
